class ShowroomsTabs {
  constructor(root) {
    this.root = root;
    this.tabs = Array.from(root.querySelectorAll(".showrooms-tab"));
    this.listWrapper = root.querySelector(".showrooms-list-wrapper");
    this.mapContainer = root.querySelector(".showrooms-map-container");

    if (this.tabs.length && this.listWrapper && this.mapContainer) this.init();
  }

  init() {
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", () => this.switchTab(tab.dataset.tab));
    });
  }

  switchTab(view) {
    const isMap = view === "map";

    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.tab === view;
      tab.classList.toggle("active", isActive);
      tab.setAttribute("aria-pressed", String(isActive));
    });

    this.listWrapper.dataset.view = view;
    this.mapContainer.classList.toggle("active", isMap);
    this.root.dataset.showroomsView = view;

    this.root.dispatchEvent(
      new CustomEvent("showrooms:view", {
        detail: { view },
      }),
    );
  }
}
